<template>
	<div class="bumper">
		<div v-if="avatar" class="bumper__avatar">
			<img :src="avatar" :alt="name" />
		</div>

		<div class="bumper__content">
			<h2 class="bumper__heading">
				<span
					v-if="titleHighlight"
					class="bumper__green"
					v-html="titleHighlight"
				/>
				<span v-if="titleText" v-html="titleText" />
			</h2>

			<p
				v-for="(paragraph, index) in paragraphs"
				:key="index"
				class="bumper__body"
				v-html="paragraph"
			/>

			<div class="bumper__footer">
				<p class="bumper__body">
					<span
						v-if="footerHighlight"
						class="bumper__red"
						v-html="footerHighlight"
					/>
					<span v-if="footerText" v-html="footerText" />
				</p>
				<BBtn
					class="bumper__action"
					size="sm"
					:disabled="updating || disabled"
					:variant="actionVariant"
					@click="$emit('toggle')"
				>
					<span v-if="!updating">{{ buttonText }}</span>
					<BSpinner v-else small label="Updating cart"></BSpinner>
				</BBtn>
			</div>
		</div>
	</div>
</template>

<script>
import { get } from 'lodash';

export default {
	name: 'AddToOrderBumper',

	props: {
		name: {
			type: String,
			required: true,
		},
		avatar: {
			type: String,
			default: '',
		},
		options: {
			type: Object,
			required: true,
		},
		added: {
			type: Boolean,
			required: true,
		},
		updating: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		titleHighlight() {
			return get(this.options, 'title.highlight', '');
		},
		titleText() {
			return get(this.options, 'title.text', '');
		},
		paragraphs() {
			return get(this.options, 'body.paragraphs', []);
		},
		footerHighlight() {
			return get(this.options, 'footer.highlight', '');
		},
		footerText() {
			return get(this.options, 'footer.text', '');
		},
		buttonText() {
			return this.added ? 'Remove from Order' : 'Add to Order';
		},
		actionVariant() {
			return this.added ? 'outline-danger' : 'outline-success';
		},
	},
};
</script>

<style lang="scss" scoped>
.bumper {
	background: var(--white);
	border-radius: var(--size-xs);
	border: 1px solid var(--gray-300);
	display: flex;
	gap: var(--size-sm);
	overflow: hidden;
	font-size: var(--size-base);
	line-height: 1.4;

	@media screen and (max-width: 992px) {
		flex-direction: column;
	}

	&__heading {
		font-size: var(--size-base);
		font-weight: 700;
		text-transform: uppercase;
		margin-bottom: var(--size-sm);
	}

	&__body {
		color: var(--gray-700);
		font-size: 12px;
		margin: 0;

		&:not(:last-of-type) {
			margin-bottom: var(--size-sm);
		}
	}

	&__green {
		color: var(--green-600);
	}

	&__red {
		color: var(--red-600);
	}

	&__avatar {
		background: #f5ffe0;
		border-right: 1px solid var(--gray-300);
		padding: var(--size-md);
		width: 120px;
		flex: none;

		@media screen and (max-width: 992px) {
			display: flex;
			justify-content: center;
			width: 100%;
			border-bottom: 1px solid var(--gray-300);
			border-right: 0;
		}

		> img {
			max-width: 100%;
			max-height: 120px;
			mix-blend-mode: multiply;
		}
	}

	&__content {
		padding: var(--size-md);
		flex: 1;
	}

	&__footer {
		display: flex;
		gap: var(--size-sm);
		align-items: center;
		margin-top: var(--size-sm);

		> p {
			flex: 1;
		}

		> button {
			flex: none;
		}

		@media screen and (max-width: 992px) {
			flex-direction: column;
		}
	}

	&__action {
		width: 150px;
		height: 40px;
		line-height: 1;

		@media screen and (max-width: 992px) {
			width: 100%;
			margin-top: var(--size-sm);
		}
	}
}
</style>
